import { formatImageUrl } from '../media_util.js';
import React, { useContext, useEffect, useRef, useState } from 'react';
import styles from './banner.module.scss';
import { trackClientExternalLink } from '../../analytics/client-event-tracking';
import { AccountContext } from '../../contexts';
import { get } from 'lodash';

function Banner({hrefUrl, imageUrl}) {
    const [shouldRender, setShouldRender] = useState(true);
    const [imageSrc, setImageSrc] = useState(null);
    const bannerEl = useRef();
    const account = useContext(AccountContext);
    const currentWidth = get(bannerEl, ['current', 'offsetWidth'], '800px');

    useEffect(() => {
        setImageSrc(formatImageUrl(imageUrl, currentWidth));
    }, [imageUrl, currentWidth]);

    if (!shouldRender) {
        return null;
    }

    const trackBannerClick = () => {
        trackClientExternalLink(account, {
            unit_type: 'header',
            unit_name: 'main',
            item_type: 'splash',
            item_name: 'banner',
            position_in_unit: 0,
            target_content_url: hrefUrl,
        });
    };

    return (
        <div ref={bannerEl} className={styles.banner}>
            <a href={hrefUrl} onClick={trackBannerClick}>
                <img
                    src={imageSrc}
                    alt={'promotion'}
                    onError={() => setShouldRender(false)} />
            </a>
        </div>
    );
}

export default Banner;
